// Use this for Local Development
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

//export const WEBSITE_URL = "https://api.pratigo.com.br";

export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;

// Comment out the above and Uncomment the below line before building the files for Production
// export const WEBSITE_URL = "https://" + window.location.hostname;
